import { Backdrop } from "exports-loader?exports=Backdrop!bootstrap/js/src/util/backdrop";

const Default = {
    backdrop: true,
}

const CLASS_NAME_BACKDROP = 'comment-backdrop'; // mettre une seule class


export class commentToggle {


    /**
    * Constructs a new parallax instance.
    *
    * @param container Where parallax applies to.
    */
    constructor(CSSSelector, config) {
        this.selector = CSSSelector;
        this._config = this._getConfig(config)
        this._backdrop = this.initializeBackDrop()
    }


    // Private

    _getConfig(config) {
        config = {
            ...Default
        }
        return config
    }


    initializeBackDrop() {
        return new Backdrop({
            className: CLASS_NAME_BACKDROP,
            isVisible: true,
            isAnimated: true,
            rootElement : "#wrapper"
        })
    }

    /**
   * Find elements
   * @return {void}
   */
    findElements() {
        this.els = document.querySelectorAll(this.selector);
    }

    /**
   * Reset Find any elements
   * @return {void}
   */
    init() {
        this.findElements();
        this.initializeBackDrop();
        // this.update();
        this.toggle();
        this.closeButton();
        this.closeOverlay();
        this.closeBtnOverlay();

    }


    closeStyle(){
        document.querySelector('body').style.removeProperty('padding-right');
        document.querySelector('body').style.removeProperty('overflow');
    }


    toggle() {

        for (let item of this.els) {
            item.addEventListener('click', (e) => {
                e.preventDefault();

                document.querySelector('body').style.overflow = 'hidden';
                document.querySelector('body').style.paddingRight = '15px';

                
                const panelToOpen = document.getElementById(item.hash.substring(1));
                if (panelToOpen.classList.contains('panel-open') === false) {
                    panelToOpen.classList.add('panel-open');

                    this._backdrop.show();
                    this.closeBtnOverlay();
                }
            });
        }
    }

    closeButton() {
        const closeBtns = document.querySelectorAll('.panel-close');
       
        for (let item of closeBtns) {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const panelToClose = item.closest(".panel");
                panelToClose.classList.remove('panel-open');

                if (item.classList.contains('close-all-panels') == true) {
                    this.closeOverlay();
                    this.closeStyle();
                }

            });
        }
    }

    closeAllPanels() {
        const panelsOpen = document.querySelectorAll('.panel-open');
        this.closeStyle();
        for (let panel of panelsOpen) {
            panel.classList.remove('panel-open');
        };
    }

    closeOverlay() {
        this._backdrop.hide();
     
    }

    closeBtnOverlay() {
        const overlay = document.querySelector('.' + CLASS_NAME_BACKDROP);
        if (overlay) {
            overlay.addEventListener('click', (e) => {
          
                e.preventDefault();
                this.closeStyle();
                this.closeOverlay();
                this.closeAllPanels();
            });
        }
    }


}
